const Facebook = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
      <circle cx="28" cy="28" r="28" fill="#3C579E" />
      <path
        d="M25.4469 38.5V29.012H22.166V25.6286H25.4476V22.5055C25.4476 19.3556 27.2493 17.5 29.971 17.5C31.2753 17.5 32.3392 17.644 32.666 17.6888V21.2265L30.475 21.2255C28.9947 21.2255 28.7177 21.9834 28.7177 23.0488V25.6286H32.5108L31.975 29.012H28.7177V38.5H25.4469Z"
        fill="white"
      />
    </svg>
  );
};

export default Facebook;
